// extracted by mini-css-extract-plugin
module.exports = {"TipContainer":"style_TipContainer__4NiMv","ShareIndicator":"style_ShareIndicator__2valw","Tips":"style_Tips__1A7uy","TipContainerVisible":"style_TipContainerVisible__2OxBb"};